import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="w-full py-12 px-6 border-t border-white/5 bg-brand-black">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="font-serif text-lg tracking-ultra-wide text-brand-gold/60">
          METANOIA
        </div>
        
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 text-[10px] tracking-[0.2em] uppercase text-white/40 font-sans">
          <span>© {year} METANOIA. {t.rights}</span>
          <div className="flex items-center gap-4">
            <Link 
              to="/imprint" 
              className="hover:text-brand-gold transition-colors duration-300"
            >
              {t.imprintLink}
            </Link>
            <span className="text-white/10">|</span>
            <Link 
              to="/privacy" 
              className="hover:text-brand-gold transition-colors duration-300"
            >
              {t.privacyLink}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}